import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';

import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';
import { reqFILE } from '../../../Utils';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'
import moment from 'moment-timezone';
import { set_language } from '../../../Utils';
import { color, Color } from '../../WEBContent/Color';

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,

	pattern_vat,
	pattern_email,
	passwordHash,
	handle_compressed_image_upload,
	repo_img_link,

} from '../../../Utils';

import { language } from './Language';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import Hosts from '../../../Hosts';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const nota_de_encomenda = useRef();
	const temporada = useRef();
	const pay_fee_available = useRef();
	const fdi_iban = useRef();

	const fee_available = useRef(false)

	const [lang, set_lang] = useState('pt');
	const [lang_id, set_lang_id] = useState('1');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')
	const [files, setFiles] = useState(null)
	const [typeAnexo, setTypeAnexo] = useState('foto')
	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])
	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	const [treeDataCV, setTreeDataCV] = useState([])

	const [files_em, set_files_em] = useState([]);
	const [files_em_name, set_files_em_name] = useState([]);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)
	const [refresh, setRefresh] = useState(0)

	const entity_types = [];
	const [aClubes, set_clubes] = useState([]);
	const [aEntityProfiles, set_entity_profiles] = useState([]);
	const [aProfiles, set_profiles] = useState([]);

	const escalaoAutoRef = useRef(''); 

	const aModalidades = [
		{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
		{ value: 'curling', label: 'Curling' },
		{ value: 'ski_alpino', label: 'Esqui alpino' },
		{ value: 'bobsled', label: 'Bobsled' },
		{ value: 'hoquei_no_gelo', label: 'Hóquei no gelo' },
		{ value: 'luge', label: 'Luge' },
		{ value: 'snowboard', label: 'Snowboard' },
		{ value: 'skeleton', label: 'Skeleton' },
		{ value: 'patinagem_artistica', label: 'Patinagem artística' },
		{ value: 'patinagem_de_velocidade', label: 'Patinagem de velocidade' },
		{ value: 'ski_freestyle', label: 'Esqui Free Style' },
		{ value: 'biatlo', label: 'Biatlo' },
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])
	const [uploading, setUploading] = useState(false);

	//Filter	
	const [showOverView, setShowOverview] = useState(true);
	const [showSportsData, setShowSportsData] = useState(false);
	const [showGuardians, setShowGuardians] = useState(false);	
	const [showSettings, setShowSettings] = useState(false);

	const INSCRICAO_VALOR = 30.0;
	const SEGURO_OPCIONAL_VALOR = 3.5;

	const calculate_age = (birthday) => {
		if (!birthday) return null;
		const birthDate = new Date(birthday);
		if (isNaN(birthDate.getTime())) return null;
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age
	};

	const entity_age = calculate_age(dados.current.info.birthday);
	const is_minor = entity_age !== null && entity_age < 18;

	let year = new Date().getFullYear();

	const ESCALOES_GERAL = [
		{ id: 'U10', label: 'U10', min: (parseInt(year) - 10), max: Infinity },
		{ id: 'U12', label: 'U12', min: (parseInt(year) - 12), max: (parseInt(year) - 11) },
		{ id: 'U14', label: 'U14', min: (parseInt(year) - 14), max: (parseInt(year) - 13) },
		{ id: 'U16', label: 'U16', min: (parseInt(year) - 16), max: (parseInt(year) - 15) },
		{ id: 'U18', label: 'U18', min: (parseInt(year) - 18), max: (parseInt(year) - 17) },
		{ id: 'U21', label: 'U21', min: (parseInt(year) - 21), max: (parseInt(year) - 18) },
		{ id: 'SENIOR', label: 'Sénior', min: (parseInt(year) - 35), max: (parseInt(year) - 22) },
		{ id: 'M35', label: 'M35', min: (parseInt(year) - 55), max: (parseInt(year) - 36) },
		{ id: 'M55', label: 'M55', min: -Infinity, max: (parseInt(year) - 56) },
	];

	const ESCALOES_SNOWBOARD = [
		{ id: 'U9', label: 'U9 (kids)', min: (parseInt(year) - 9), max: Infinity },
		{ id: 'U11', label: 'U11 (SuperGrom)', min: (parseInt(year) - 11), max: (parseInt(year) - 10) },
		{ id: 'U13', label: 'U13 (SuperGrom)', min: (parseInt(year) - 13), max: (parseInt(year) - 12) },
		{ id: 'U15', label: 'U15 (Grom)', min: (parseInt(year) - 15), max: (parseInt(year) - 14) },
		{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: (parseInt(year) - 18), max: (parseInt(year) - 16) },
		{ id: 'ABSOLUTO', label: 'Absoluto', min: (parseInt(year) - 41), max: (parseInt(year) - 19) },
		{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: (parseInt(year) - 42) },
	];

	const ESCALOES_PATINAGEM = [
		{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
		{ id: 'NOVATOS', label: 'Novatos' },
		{ id: 'JUNIORES', label: 'Juniores' },
		{ id: 'SENIORES', label: 'Seniores' },
		{ id: 'ADULTOS', label: 'Adultos' },
	];

	const OPCOES_ESCALAO = {
		geral: ESCALOES_GERAL,
		snowboard: ESCALOES_SNOWBOARD,
		patinagem: ESCALOES_PATINAGEM,
	};

	const custom_label_styles = {
		color: color.corShadow.hexa,
		padding: "1px 15px",
		fontSize: '14px',
	}

	const custom_input_styles = {
		borderRadius: "35px",
		padding: "10px 20px",
		fontSize: "14px",
		border: "1px solid #ced4da",
		outline: "none",
	};

	const custom_select_styles = {
		container: base => ({
			...base,
			width: '100%',
			borderRadius: "35px",
		}),
		control: base => ({
			...base,
			borderRadius: "35px",
			padding: "2px 10px",
			fontSize: '14px',
		}),
		menu: base => ({
			...base,
			borderRadius: "35px",
		}),
	};

	const change_nacionalidade = e => {


		console.log('e.value', e.value)

		set_dados(dados.current.info.identificacao.nacionalidade = e.value);

		console.log('dados.current.info.identificacao.nacionalidade', dados.current.info.identificacao.nacionalidade)

		setRefresh(r => r + 1)
	}

	const change_country = e => {

		// set_cities([])
		// set_villages([])

		// set_dados(dados.current.addresses[0].city = '');
		// set_dados(dados.current.addresses[0].village = '');
		// set_dados(dados.current.addresses[0].region = '');

		// if (e.value === "Portugal") {

		//	set_show_district_city_village('')

		//	if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
		//		obter_distritos_pt(set_districts)
		//	}
		// }
		// else {
		//	set_show_district_city_village('d-none')
		// }

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const change_identification_type = e => {
		set_dados(dados.current.info.identification.tipo_identificacao = e.value);
	}

	/*const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return } 
				//alert('Distrito não encontrado!')
			)
	}*/

	const fetch_id_info = async (id_serch) => {

		let iban_aux = await reqGET(`${Hosts.SIMCore_API}/intranet/company/settings/${dados.current.info.companycode}`)
		let temporada_aux = await reqGET(`${Hosts.SIMCore_API}/intranet/components/type/${dados.current.info.companycode}/temporada`)
		let res_ep = await reqGET(`${Hosts.SIMCore_API}/entities/profiles/${dados.current.info.companycode}`)
		// let res_p = await reqGET(`${Hosts.SIMCore_API}/profiles/${dados.current.info.companycode}`)
		let res_c = await reqGET(`${api_crud_base}/entities/list/${dados.current.info.companycode}/Clube`);

		if(Array.isArray(temporada_aux.data)) {
			let t_aux = temporada_aux.data.find(e => e.info.active)
			set_dados(temporada.current = t_aux);
		
			let purchase_order = await reqGET(`${Hosts.SIMCore_API}/store/order/client/season/${dados.current.info.companycode}/${id_serch}/${t_aux.id}`)
			if(purchase_order !== undefined && purchase_order !== null) {
				if(purchase_order.data) {
					set_dados(pay_fee_available.current = false)
				}
				else {
					set_dados(pay_fee_available.current = true)
				}
			}
		
		}
		if(Array.isArray(res_ep.data)) {
			let aux_ep = []
			res_ep.data.forEach(el => {
				if(parseInt(el.id) === 53 || parseInt(el.id) === 56 || parseInt(el.id) === 52 || parseInt(el.id) === 62) {
					aux_ep.push({
						value: el.id,
						label: el.name,
					})
				}
			})
			console.log('aux_ep', aux_ep)
			set_entity_profiles(aux_ep);
		}
		if(Array.isArray(res_c.data)) {
			let aux_c = []
			res_c.data.forEach(el => {
				aux_c.push({
					value: el.id,
					label: el.name,
				})
			})
			set_clubes(aux_c);
		}

		if(Array.isArray(iban_aux.data)) {
			set_dados(fdi_iban.current = iban_aux.data[0].iban)
		}

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				let aux_doc_cv = []
				let i = 0
				console.log('res.data[0].info.cv', res.data[0].info.cv)

				if (!Array.isArray(res.data[0].info.cv)) {
					res.data[0].info.cv = []
				}

				if (res?.data[0]?.info?.cv !== undefined) {
					res.data[0].info.cv.forEach((el, k) => {

						aux_doc_cv = []
						aux_doc_cv[k] = []
						aux_doc_cv[k][1] = []

						aux_doc_cv[k][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
					})
					console.log('res.data[0].info.cv', res.data[0].info.cv)
				}
				console.log('aux_doc_cv', aux_doc_cv)
				setTreeDataCV(aux_doc_cv)

				if (res.data[0].profile.name === 'Administrador') {
					if (getTokenInfo().profile === 'Administrador') {
						set_dados(dados.current = res.data[0]);
					} else {
						setRedirect(true);
					}
				}
				else {

					// let anoEpoca = getAnoEpocaAtual();

					// let sugestao = calcularEscalao(
					// 	dados.current.info.birthday,
					// 	dados.current.info.modalidades,
					// 	anoEpoca
					// );

					// if (!res?.data[0].info.escalao || res?.data[0].info.escalao === escalaoAutoRef.current) {
					// 	escalaoAutoRef.current = sugestao;
					// 	set_dados(res.data[0].info.escalao = sugestao);
					// }

					set_dados(dados.current = res.data[0]);
				}

				/*
				if(Array.isArray(res.data[0].info.temporadas)) {
					let aux = res.data[0].info.temporadas.find(e => parseInt(e.id) === parseInt(temporada.current.id))
					if(aux !== undefined) {
						set_dados(pay_fee_available.current = false)
					}
					else {
						set_dados(pay_fee_available.current = true)
					}
				}
				else {
					set_dados(pay_fee_available.current = true)
				}
				*/

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)
		window.location.reload()

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	const getAnoEpocaAtual = () => {
		const hoje = new Date();
		const anoAtual = hoje.getFullYear();
		const mesAtual = hoje.getMonth(); // 0 = janeiro, 6 = julho

		// Época muda em julho (mês índice 6)
		return mesAtual >= 6 ? anoAtual : anoAtual - 1;
	};

	useEffect(() => {
		const anoEpoca = getAnoEpocaAtual();

		const sugestao = calcularEscalao(
			dados.current.info.birthday,
			dados.current.info.modalidades,
			anoEpoca
		);

		escalaoAutoRef.current = sugestao;
		set_dados(dados.current.info.escalao = sugestao);

	}, [dados.current.info.birthday, JSON.stringify(dados.current.info.modalidades)]);

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {

		obter_paises_em_pt(set_countries);
		
		set_dados(pay_fee_available.current = false)
		set_dados(fdi_iban.current = '')

		set_lang(localStorage.getItem('lang'))

		clean_data();

		if (getTokenInfo().profile !== '') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {
				setLoading(false);
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false);
				})
				return
			}
		}
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const get_data_func = () => {
		let data = moment().tz("Europe/Lisbon").format('YYYY-MM-DDTHH:mm:ss.SSSZ')
		return data.substring(0, data.length - 6) + 'Z'
	}

	function getNumberOfDays(start, end) {
		const date1 = new Date(start);
		const date2 = new Date(end);

		// One day in milliseconds
		const oneDay = 1000 * 60 * 60 * 24;

		// Calculating the time difference between two dates
		const diffInTime = date2.getTime() - date1.getTime();

		// Calculating the no. of days between two dates
		const diffInDays = Math.round(diffInTime / oneDay);

		return diffInDays;
	}

	const pay_fee = async () => {

		let result = await verify_required()

		console.log('result', result)

		if(result === true) {

			let date_today = new Date()
			let timestamp_aux = get_data_func()

			let valor_inscricao = INSCRICAO_VALOR
			let valor_total = 0.00
			let valor_seguro = SEGURO_OPCIONAL_VALOR

			let start_0 = date_today.getFullYear() + '-09-01'
			let start_1 = date_today.getFullYear() + '-10-31'
			let start_2 = date_today.getFullYear() + '-11-30'
			let end = date_today.getFullYear() + '-' + (date_today.getMonth() + 1).toString().padStart(2, '0') + '-' + date_today.getDate().toString().padStart(2, '0')

			let diff_0 = getNumberOfDays(start_0, end)
			let diff_1 = getNumberOfDays(start_1, end)
			let diff_2 = getNumberOfDays(start_2, end)

			console.log('diff_0', diff_0)
			console.log('diff_1', diff_1)
			console.log('diff_2', diff_2)
			console.log('temporada.current', temporada.current)
			console.log('dados.current.info.escalao', dados.current.info.escalao)

			if(parseInt(diff_0) >= 0 && parseInt(diff_1) <= 0) {
				console.log('diff_0')

				valor_inscricao = 0.00

				if(dados.current.info.escalao.toLowerCase() === 'u10' || dados.current.info.escalao.toLowerCase() === 'u9 (kids)') {
					console.log('diff_0_1')
					if(dados.current.info.inscricao === undefined) {
						dados.current.info.inscricao = []
					}
					dados.current.info.inscricao.push({
						escalao: dados.current.info.escalao,
						temporada: {
							id: temporada.current !== undefined && temporada.current !== null ? temporada.current.id : '',
							name: temporada.current !== undefined && temporada.current !== null ? temporada.current.info.name : ''
						}, 
						data_inscricao: end,
						timestamp: timestamp_aux,
						valor: valor_inscricao
					})

				}
				else {
					valor_inscricao = 10.0
				}

				console.log('valor_total', valor_total)

			}
			else if(parseInt(diff_1) >= 0 && parseInt(diff_2) <= 0) {
				if(dados.current.info.escalao.toLowerCase() === 'u10' || dados.current.info.escalao.toLowerCase() === 'u9 (kids)') {
					valor_inscricao = 20.0
				}
				else {
					valor_inscricao = 20.0
				}				
			}
			else {
				if(dados.current.info.escalao.toLowerCase() === 'u10' || dados.current.info.escalao.toLowerCase() === 'u9 (kids)') {
					valor_inscricao = 30.0
				}
				else {
					valor_inscricao = 30.0
				}	
			}
			valor_total = valor_inscricao

			set_dados(nota_de_encomenda.current = {
				id: '',
				info: {
					companycode: dados.current.info.companycode,
					tipo_documento: 'nota_de_encomenda',
					origin: 'web',
					numero: '',
					serie: '',
					data: date_today.getFullYear() + '-' + (date_today.getMonth() + 1).toString().padStart(2, '0') + '-' + date_today.getDate().toString().padStart(2, '0'), 	// 'AAAA-MM-DD',
					timestamp: timestamp_aux, 	// 'with all info',
					id_usado_para_gerar_pagamento: '',
					pagamento_pendente: 0,
					metodo_de_pagamento: 0,
					documento: {
						rmb: {
							rmb_ref: '',
							rmb_ent: '',
							rmb_pag: '',
						},
						user_info : {
							id_user: dados.current.id,
							username: dados.current.info.username,	// para fazer match
							name: dados.current.info.name,
							birthday: dados.current.info.birthday,
							numero_identificacao: dados.current.info.identificacao.numero_identificacao,
							clube: Array.isArray(dados.current.info.clube) && dados.current.info.clube.length > 0 ? dados.current.info.clube[0].name : '',
							funcao: 'Atleta',
							numero_licenca: dados.current.info.numero_licenca,
							seguro_opcional: parseInt(dados.current.info.seguro_opcional) === 1 ? true : false,
							vat: dados.current.info.vat,
							addresses: dados.current.addresses,
							contacts: dados.current.contacts,
							obs: '',
						},
						linhas:[
							{
							    id_produto: 					'',
							    designacao: 					'Inscrição',
								subname: 						'',
								category: 						dados.current.info.escalao,
								observation:					(temporada.current !== undefined && temporada.current !== null ? 'Temporada: ' + temporada.current.info.name : ''),
							    unidade: 						'un',

								escalao:						dados.current.info.escalao,
								temporada: {
									id: temporada.current !== undefined && temporada.current !== null ? temporada.current.id : '',
									name: temporada.current !== undefined && temporada.current !== null ? temporada.current.info.name : ''
								}, 		

							    quantidade: 					1.00,
							    preco_unitario: 				valor_inscricao, 									// 0.00000000, 

							    taxa_iva: 						0.00,
							    taxa_desconto_linha: 			0.00,

							    total_iliquido: 				valor_inscricao,                  		   			// preco_unitario * quantidade

							    total_desconto: 				0.00,                   	           			// total_iliquido * taxa_desconto_linha * 0.01
							    total_iliquido_com_desconto: 	valor_inscricao,              						// total_iliquido - total_desconto

							    total_iva: 						0.00,                	                   		// total_iliquido_com_desconto * taxa_iva * 0.01
							    total_com_iva: 					valor_inscricao,    	                       		// total_iliquido_com_desconto + total_iva

							    total_liquido:					valor_inscricao 									// total_com_iva
							},
						],
			
						// Valores do Globais do Documento
						total_iliquido_documento: valor_inscricao,                          						// soma do total_iliquido_com_desconto de todas as linhas 
						total_desconto_linha_documento: 0.00,                           						// soma do total_desconto de todas as linhas 
						taxa_desconto_global: 0,                                        						// em %
						valor_desconto_global_a_aplicar: 0.00, 
						total_iliquido_documento_com_deconto_linha_e_global: valor_inscricao,						// total_iliquido_documento - (total_desconto_linha_documento + valor_desconto_global_a_aplicar)

						total_iva_documento: 0.00,
		
						total_documento: valor_inscricao, 															// total_iliquido_documento_com_deconto_linha_e_global + total_iva_documento
					}
				}
			})
			console.log('valor_total', valor_total)

			// SEGURO
			if(dados.current.info.seguro_opcional !== undefined && dados.current.info.seguro_opcional !== null && parseInt(dados.current.info.seguro_opcional) === 1) {
				valor_total = parseFloat(valor_total) + parseFloat(valor_seguro)

				let enc_seguro = {
					id_produto: 					'',
					designacao: 					'Seguro opcional',
					subname: 						'',
					category: 						'',
					observation:					(temporada.current !== undefined && temporada.current !== null ? 'Temporada: ' + temporada.current.info.name : ''),
					unidade: 						'un',

					escalao:						dados.current.info.escalao,
					temporada: {
						id: temporada.current !== undefined && temporada.current !== null ? temporada.current.id : '',
						name: temporada.current !== undefined && temporada.current !== null ? temporada.current.info.name : ''
					}, 		

					quantidade: 					1.00,
					preco_unitario: 				valor_seguro, 									// 0.00000000, 

					taxa_iva: 						0.00,
					taxa_desconto_linha: 			0.00,

					total_iliquido: 				valor_seguro,                  		   			// preco_unitario * quantidade

					total_desconto: 				0.00,                   	           			// total_iliquido * taxa_desconto_linha * 0.01
					total_iliquido_com_desconto: 	valor_seguro,              						// total_iliquido - total_desconto

					total_iva: 						0.00,                	                   		// total_iliquido_com_desconto * taxa_iva * 0.01
					total_com_iva: 					valor_seguro,    	                       		// total_iliquido_com_desconto + total_iva

					total_liquido:					valor_seguro 									// total_com_iva
				}
				nota_de_encomenda.current.info.documento.linhas.push(enc_seguro)

				nota_de_encomenda.current.info.documento.total_iliquido_documento = valor_total
				nota_de_encomenda.current.info.documento.total_iliquido_documento_com_deconto_linha_e_global = valor_total
				nota_de_encomenda.current.info.documento.total_documento = valor_total

			}
		
			console.log('getTokenInfo()', getTokenInfo())
			console.log('dados.current', dados.current)
			console.log('nota_de_encomenda.current', nota_de_encomenda.current)
			console.log('valor_total', valor_total)

			if(parseFloat(valor_total) === 0) {

				// nota_de_encomenda.current.info.pagamento_pendente = 1
				nota_de_encomenda.current.info.metodo_de_pagamento = ''

				set_paymet('free', '')
	
			}
			else {
				document.getElementById('btn_modal_payment_type').click()

				// Swal.fire('', '[ASSEC] A aguardar dados da Easypay para finalizar este passo.', 'warning')	
			}
		
		}

		setRefresh(r => r + 1)
	}

	const set_paymet = async (type, id) => {
		console.log(type)

		set_dados(nota_de_encomenda.current.info['metodo_de_pagamento'] = id)

		let id_pagamento = Date.now() + '' + getTokenInfo().id
		set_dados(nota_de_encomenda.current.info['id_usado_para_gerar_pagamento'] = id_pagamento)

		if(type === 'mbw') {
			const { value: formValues } = await Swal.fire({
				title: 'Pagamento por MBWay',
				html:
					'<label>Número de telemóvel associado à aplicação MBWay</label>' +
					'<input id="swal-input1" type="text" class="form-control mb-2" required>',
				target: document.querySelector('.modal-content'), // 👈 Altera para a classe/ID da tua modal
				focusConfirm: false,
				showCancelButton: true,
				cancelButtonText: language[lang].cancel,
				preConfirm: () => {
					if(document.getElementById('swal-input1').value === '') {
						Swal.fire('', document.getElementById('swal-input1').value, 'info')
					}
					else {
						return [
							document.getElementById('swal-input1').value
						]
					}
				}
			})

			if(formValues) {
				if(formValues[0] !== undefined && formValues[0] !== '') {

					Swal.fire({
						title: language[lang].confirm_purchase_title,
						text: language[lang].confirm_purchase_text,
						icon: 'question',
						showCancelButton: true,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].confirm_purchase_confirm,
						cancelButtonText: language[lang].confirm_purchase_cancel
					})
					.then((result) => {
						if (result.isConfirmed) {
			
							nota_de_encomenda.current.info['metodo_de_pagamento'] = id
			
							if(nota_de_encomenda.current.info.documento.user_info.vat === '') {
								nota_de_encomenda.current.info.documento.user_info.vat = '999999990'
							}

							reqPOST(`${Hosts.SIMCore_API}/store/order`, nota_de_encomenda.current)
								.then(() => { 
			
									if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '-1') {
										get_payment_data('mbw', formValues[0])
									}
									else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '0') {
										get_payment_data('cc', '')
									}
									else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '1') {
										get_payment_data('mb', '')
									}

								})
								.catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))
				
						}
					})
				}
				else {
					Swal.fire({
					title: 'Pagamento por MBWay',
					html: 'É obrigatório introduzir o número de telemóvel associado à aplicação MBWay',
					timer: 2000,
					timerProgressBar: true,
					didOpen: () => {
					},
					willClose: () => {
						set_paymet(type, id)
					}
					}).then((result) => {
						if (result.dismiss === Swal.DismissReason.timer) {
							set_paymet(type, id)
						}
					})
				}
			}
		}
		else {
			console.log('-----333333')
			Swal.fire({
				title: language[lang].confirm_purchase_title,
				text: language[lang].confirm_purchase_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].confirm_purchase_confirm,
				cancelButtonText: language[lang].confirm_purchase_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					nota_de_encomenda.current.info['metodo_de_pagamento'] = id
	
					if(nota_de_encomenda.current.info.documento.user_info.vat === '') {
						nota_de_encomenda.current.info.documento.user_info.vat = '999999990'
					}

					reqPOST(`${Hosts.SIMCore_API}/store/order`, nota_de_encomenda.current)
						.then(() => { 
	
							if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '-1') {
								get_payment_data('mbw', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '0') {
								get_payment_data('cc', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '1') {
								get_payment_data('mb', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '2') {
								get_payment_data('tb', '')
							}
							else if(nota_de_encomenda.current.info['metodo_de_pagamento'] === '') {
								get_payment_data('free', '')
							}

						})
						.catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))

				}
			})
		}

		if(type !== 'free') {
			document.getElementById('btn_modal_payment_type').click()
		}

		set_dados(pay_fee_available.current = false)
	}

	const get_payment_data = async (type, mbw_number) => {

		/*
		const payload = {
			type: ["sale"],
			method: type,
			value: parseFloat(nota_de_encomenda.current.info.documento.total_documento),
			currency: "EUR",
			expiration_time: "2022-10-04", 
			capture: {
				transaction_key: nota_de_encomenda.current.info.id_usado_para_gerar_pagamento,
				descriptive: "FDI",
				capture_date: nota_de_encomenda.current.info.data,
			},
			customer: {
				name: '',
				email: nota_de_encomenda.current.info.documento.user_info.contacts[0].email,
				phone: mbway_mobile_phone,
				phone_indicative: '+351',
				fiscal_number: nota_de_encomenda.current.info.documento.user_info.vat,
				key: nota_de_encomenda.current.info.id_usado_para_gerar_pagamento,
				language: 'PT',
			}
		} 
		*/

		// let mb_e = ''
		// let mb_r = ''
		// let data_limite = ''

		let body = { 
			key: nota_de_encomenda.current.info.id_usado_para_gerar_pagamento, 
			value: parseFloat(nota_de_encomenda.current.info.documento.total_documento), 
			method: type, 
			phone: mbw_number 
		}

		await reqPOST(`${Hosts.SIMCore_API}/store/payment/checkout/`, body)
			.then(async (res) => { 

				console.log('res', res)

				if(type === 'mb') {

				}
				else if(type === 'mbw') {

				}

				await reqPOST(`${Hosts.SIMCore_API}/store/purchase/payment`, {id: '', info: {id: '' + nota_de_encomenda.current.info.id_usado_para_gerar_pagamento + '', companycode: '' + nota_de_encomenda.current.info.companycode + '', obj: res.data} })
					.then(async () => { 

						console.log('DONE!!!')

						await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${nota_de_encomenda.current.info.id_usado_para_gerar_pagamento}`)
							.then(async () => { 

								if(type === 'cc') {

									console.log('CC', nota_de_encomenda.current.info['metodo_de_pagamento'])
									console.log('CC', res.data.response.method.url)

									// compose_email(res_2.data[0].id, type, '', '', '')
									window.open(res.data.response.method.url, '_self')

								}
								else if(type === 'mbw') {
									// Mensagem de sucesso
									console.log('MBW', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);
								}
								else if(type === 'mb') {
									// Mensagem de sucesso

									console.log('MB', nota_de_encomenda.current.info['metodo_de_pagamento'])
									// compose_email(res_2.data[0].id, type, mb_e, mb_r, data_limite)

									await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${nota_de_encomenda.current.info.id_usado_para_gerar_pagamento}`)
										.then(async (res_order) => { 

											res_order.data[0].info.documento.rmb.rmb_ref = res.data.response.method.reference
											res_order.data[0].info.documento.rmb.rmb_ent = res.data.response.method.entity
											res_order.data[0].info.documento.rmb.rmb_pag = parseFloat(body.value).toFixed(2).toString().replace('.', ',')

											await reqPUT(`${Hosts.SIMCore_API}/store/order`, res_order.data[0] )
												.then(_ => {} )
												.catch(_ => {} ) 
		
											// Swal.fire('', language[lang].encomenda_finalizada, 'info')
		
											Swal.fire({
												icon: 'info',
												html: language[lang].encomenda_finalizada,
												showConfirmButton: false
											})
		
											setTimeout(() => {
												// window.open(Hosts.WEB_SITE_URI, '_self')
											}, 3000);

										})
										.catch(erro => console.log(erro)) 

								} 
								else if(type === 'tb') {
									// Mensagem de sucesso
									console.log('TB', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);

								}
								else if(type === 'free') {
									// Mensagem de sucesso
									console.log('FREE', nota_de_encomenda.current.info['metodo_de_pagamento'])

									Swal.fire({
										icon: 'info',
										html: language[lang].encomenda_finalizada,
										showConfirmButton: false
									})

									setTimeout(() => {
										// window.open(Hosts.WEB_SITE_URI, '_self')
									}, 3000);

								}

							})
							.catch(erro => console.log(erro)) 

					})
					.catch(() => {

						console.log('error')

					})

			})
			.catch(() => {

				console.log('error')

			})

	}

	const verify_required = async () => {

		let result = false
		let aFalse = []

		// NOME
		if(dados.current.info.name !== undefined && dados.current.info.name !== null && dados.current.info.name !== '') {
			result = true
		}
		else {
			aFalse.push('Nome')
			result = false
		}

		// EMAIL
		if(dados.current.info.email !== undefined && dados.current.info.email !== null && dados.current.info.email !== '') {
			result = true
		}
		else {
			
			aFalse.push('Email')
			result = false
		}

		// IDENTIFICACAO
		if(dados.current.info.identificacao !== undefined && dados.current.info.identificacao !== null) {
			if(dados.current.info.identificacao.tipo_identificacao !== undefined && dados.current.info.identificacao.tipo_identificacao !== null && dados.current.info.identificacao.tipo_identificacao !== '') {
				result = true
			}
			else {
				aFalse.push('Tipo de Identificação')
				result = false
			}
			if(dados.current.info.identificacao.numero_identificacao !== undefined && dados.current.info.identificacao.numero_identificacao !== null && dados.current.info.identificacao.numero_identificacao !== '') {
				result = true
			}
			else {
				aFalse.push('Número de Identificação')
				result = false
			}
			if(dados.current.info.identificacao.validade_identificacao !== undefined && dados.current.info.identificacao.validade_identificacao !== null && dados.current.info.identificacao.validade_identificacao !== '') {
				result = true
			}
			else {
				aFalse.push('Validação da Identificação')
				result = false
			}
			// NACIONALIDADE
			if(dados.current.info.identificacao.nacionalidade !== undefined && dados.current.info.identificacao.nacionalidade !== null && dados.current.info.identificacao.nacionalidade !== '') {
				result = true
			}
			else {
				aFalse.push('Nacionalidade')
				result = false
			}
			// NATURALIDADE
			if(dados.current.info.identificacao.naturalidade !== undefined && dados.current.info.identificacao.naturalidade !== null && dados.current.info.identificacao.naturalidade !== '') {
				result = true
			}
			else {
				aFalse.push('Naturalidade')
				result = false
			}
		}

		// SEGURO
		if(dados.current.info.seguro_opcional !== undefined && dados.current.info.seguro_opcional !== null && dados.current.info.seguro_opcional !== '') {
			result = true
		}
		else {
			aFalse.push('Seguro')
			result = false
		}

		// GENERO
		if(dados.current.info.genero !== undefined && dados.current.info.genero !== null && dados.current.info.genero !== '') {
			result = true
		}
		else {
			aFalse.push('Género')
			result = false
		}

		// DATA NASCIMENTO
		if(dados.current.info.birthday !== undefined && dados.current.info.birthday !== null && dados.current.info.birthday !== '') {
			result = true
		}
		else {
			aFalse.push('Data de Nascimento')
			result = false
		}

		// PROFISSAO
		if(dados.current.info.profissao !== undefined && dados.current.info.profissao !== null && dados.current.info.profissao !== '') {
			result = true
		}
		else {
			aFalse.push('Profissão')
			result = false
		}
		
		// CASO PROFISSAO
		if(dados.current.info.profissao !== undefined && dados.current.info.profissao !== null && dados.current.info.profissao.trim().toLowerCase() !== 'estudante') {
			if(dados.current.info.empresa !== undefined && dados.current.info.empresa !== null && dados.current.info.empresa !== '') {
				result = true
			}
			else {
				aFalse.push('Empresa')
				result = false
			}
		}

		// CASO PROFISSAO ESTUDANTE
		if(dados.current.info.profissao !== undefined && dados.current.info.profissao !== null && dados.current.info.profissao.trim().toLowerCase() === 'estudante') {
			if(dados.current.info.estabelecimento_ensino !== undefined && dados.current.info.estabelecimento_ensino !== null && dados.current.info.estabelecimento_ensino !== '') {
				result = true
			}
			else {
				aFalse.push('Establecimento de Ensino')
				result = false
			}
		}

		// ADDRESSES
		if(Array.isArray(dados?.current?.addresses) && dados?.current?.addresses.length > 0) {
			if(dados.current.addresses[0].address_detail !== undefined && dados.current.addresses[0].address_detail !== null && dados.current.addresses[0].address_detail !== '') {
				result = true
			}
			else {
				aFalse.push('Morada')
				result = false
			}

			if(dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country !== null && dados.current.addresses[0].country !== '') {
				result = true
			}
			else {
				aFalse.push('País')
				result = false
			}
			
			if(dados.current.addresses[0].localidade !== undefined && dados.current.addresses[0].localidade !== null && dados.current.addresses[0].localidade !== '') {
				result = true
			}
			else {
				aFalse.push('Localidade')
				result = false
			}

			if(dados.current.addresses[0].country !== undefined && dados.current.addresses[0].country !== null && dados.current.addresses[0].country.toLowerCase() === 'portugal') {
				if(dados.current.addresses[0].postal_code !== undefined && dados.current.addresses[0].postal_code !== null && dados.current.addresses[0].postal_code !== '') {
					result = true
				}
				else {
					aFalse.push('Código-Postal')
					result = false
				}
				if(dados.current.addresses[0].region !== undefined && dados.current.addresses[0].region !== null && dados.current.addresses[0].region !== '') {
					result = true
				}
				else {
					aFalse.push('Distrito / Estado')
					result = false
				}
			}
		}
		else {
			aFalse.push('Morada')
			result = false
		}

		// CONTACTS
		if(Array.isArray(dados?.current?.contacts) && dados?.current?.contacts.length > 0) {
			if(dados.current.contacts[0].mobile_phone !== undefined && dados.current.contacts[0].mobile_phone !== null && dados.current.contacts[0].mobile_phone !== '') {
				result = true
			}
			else {
				aFalse.push('Telemóvel')
				result = false
			}
			if(dados.current.contacts[0].email !== undefined && dados.current.contacts[0].email !== null && dados.current.contacts[0].email !== '') {
				result = true
			}
			else {
				result = false
			}
		}
		else {
			aFalse.push('Contactos')
			result = false
		}

		// EXAME MEDICO
		if(Array.isArray(dados?.current?.info?.exame_medico) && dados?.current?.info?.exame_medico.length > 0) {
			result = true
		}
		else {
			aFalse.push('Exame Médico')
			result = false
		}

		// FOTOGRAFIA
		if(Array.isArray(dados?.current?.info?.foto) && dados?.current?.info?.foto.length > 0) {
			result = true
		}
		else {
			aFalse.push('Fotografia')
			result = false
		}

		if(is_minor) {
			// pai - mae - encarregado_educacao

			let i = 0
			if(dados?.current?.info?.encarregados !== undefined && dados?.current?.info?.encarregados !== null) {
				if(dados?.current?.info?.encarregados?.pai !== undefined && dados?.current?.info?.encarregados?.pai !== null) {
					if(dados?.current?.info?.encarregados?.pai?.nome !== undefined && dados?.current?.info?.encarregados?.pai?.nome !== null && dados?.current?.info?.encarregados?.pai?.nome !== '' && dados?.current?.info?.encarregados?.pai?.contacto !== undefined && dados?.current?.info?.encarregados?.pai?.contacto !== null && dados?.current?.info?.encarregados?.pai?.contacto !== '') {
						i = 1
					}
				}
				if(dados?.current?.info?.encarregados?.mae !== undefined && dados?.current?.info?.encarregados?.mae !== null) {
					if(dados?.current?.info?.encarregados?.mae?.nome !== undefined && dados?.current?.info?.encarregados?.mae?.nome !== null && dados?.current?.info?.encarregados?.mae?.nome !== '' && dados?.current?.info?.encarregados?.mae?.contacto !== undefined && dados?.current?.info?.encarregados?.mae?.contacto !== null && dados?.current?.info?.encarregados?.mae?.contacto !== '') {
						i = 1
					}
				}
				if(dados?.current?.info?.encarregados?.encarregado_educacao !== undefined && dados?.current?.info?.encarregados?.encarregado_educacao !== null) {
					if(dados?.current?.info?.encarregados?.encarregado_educacao?.nome !== undefined && dados?.current?.info?.encarregados?.encarregado_educacao?.nome !== null && dados?.current?.info?.encarregados?.encarregado_educacao?.nome !== '' && dados?.current?.info?.encarregados?.encarregado_educacao?.contacto !== undefined && dados?.current?.info?.encarregados?.encarregado_educacao?.contacto !== null && dados?.current?.info?.encarregados?.encarregado_educacao?.contacto !== '') {
						i = 1
					}
				}
			}

			if(i > 0) {
				result = true
			}
			else {
				aFalse.push('Pais ou Encarregado de Educação')
				result = false
			}
		}

		if(Array.isArray(aFalse) && aFalse.length > 0) {
			result = false

			let sFalse = '<ol class="text-start" style="font-family: monospace;">'
			aFalse.forEach(el => {
				sFalse += '<li>' + el + '</li>'
			})
			sFalse += '</ol>'

			console.log('dados.current', dados.current)

			Swal.fire('Preenchimento em falta', sFalse, 'warning')
		}

		return result

	}

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')
			if ((dados.current.info.foto === undefined || dados.current.info.foto === null || dados.current.info.foto === "") && files?.length > 0) {
				console.log("O dados current ficou vazio mas entrei aqui para trocar pela imagem dos ficheiros")
				set_dados(dados.current.info.foto = files)
			}
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								files_image.forEach(async (el_image) => {
									if (el_image !== null) {
										if (el_image.files.length > 0) {
											await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
										}
									}
								})
								set_files_image([])
								set_image_base64([])
								// set_photo_base64('')

								files_doc.forEach(async (el_doc) => {
									if (el_doc !== null) {
										await uploadFilesDoc(el_doc.files, el_doc.order, 'cv', el_doc.langid, el_doc.lang)
									}
								})
								set_files_doc([])
								set_files_doc_name([])

								files_em.forEach(async (el_em) => {
									if (el_em !== null) {
										await uploadFilesDoc(el_em.files, el_em.order, 'em', el_em.langid, el_em.lang)
									}
								})
								set_files_em([])
								set_files_em_name([])

								// props.history.push(endpoints.list) 
							})
							.catch((error) => Swal.fire(language[lang].edit_error, error.toString(), 'info'))
					}
				})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								props.history.push(endpoints.list)
								files_image.forEach(async (el_image) => {
									if (el_image !== null) {
										if (el_image.files.length > 0) {
											await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
										}
									}
								})
								set_files_image([])
								set_image_base64([])
								// set_photo_base64('')

								files_doc.forEach(async (el_doc) => {
									if (el_doc !== null) {
										await uploadFilesDoc(el_doc.files, el_doc.order, 'cv', el_doc.langid, el_doc.lang)
									}
								})
								set_files_doc([])
								set_files_doc_name([])

							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})
		}
	}

	/*
	const handleSubmit = async e => {
		e.preventDefault();
	
		Swal.fire({
			title: language[lang][is_edit ? "edit_title" : "insert_title"],
			text: language[lang][is_edit ? "edit_text" : "insert_text"],
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang][is_edit ? "edit_confirm" : "insert_confirm"],
			cancelButtonText: language[lang][is_edit ? "edit_cancel" : "insert_cancel"]
		})
		.then((result) => {
			if (result.isConfirmed) {
	
				if (is_password) {
					let password = new_password;
					dados.current.info.password = passwordHash(password);
				}
	
				const request = is_edit ? reqPUT(api_crud_route, dados.current) : reqPOST(api_crud_route, dados.current);
	
				request
					.then(() => {
						set_new_password('');
						set_confirm_password('');
	
						if (!is_edit || is_password) {
							props.history.push(endpoints.list);
						}
	
						if (files.length > 0) {
							console.log("entrei aqui");
							handleTemplateFileUpload(files, 0, typeAnexo);
						}
	
						setFiles([]);
					})
					.catch(() => Swal.fire(language[lang][is_edit ? "edit_error" : "insert_error"], '', 'info'));
			}
		});
	};
	

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}
	*/

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							/* alert(res.status === 200 ?
								'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};


	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}


	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info.identificacao[name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_emergency = (e) => {
		const { name, value } = e.target;

		if(dados.current.info.emergencia === undefined) {
			dados.current.info.emergencia = {}
		}

		set_dados(dados.current.info.emergencia[name] = value)


		console.log('dados.current.info.emergencia', dados.current.info.emergencia)

	}

	const handle_change_info_parent = (e) => {
		const { name, value } = e.target;

		if(dados.current.info.parent === undefined) {
			dados.current.info.parent = {}
		}

		set_dados(dados.current.info.parent[name] = value)

	}

	/* 
	const handleFileChange = (event) => {
		const file = event.target.files[0];
		if (file && file.type.startsWith('image/')) {
			setFiles([file]);
			set_dados(dados.current.info.foto = files)			
		} else {
			alert('Por favor, selecione apenas imagens.');
		}
	};
	*/

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		// filesArray.forEach(async (v, k) => {
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				console.log('1')
				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))
				//storedFiles.push(v);

				console.log('2')
				await convertBase64(v)
					.then((base64) => {
						// console.log('base64', base64)

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				console.log('3')

				if (filesArray.length === (k + 1)) {
					//set_dados(dados.current,)
					//setRefresh(refresh + 1)
					setRefresh(refresh + parseInt(v.size) + k)
				}


				console.log('4')

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}
		// });

		console.log('storedFiles', storedFiles)


		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {

		set_dados(dados.current.info.foto = [])
	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_name(aux2)

				let aux_doc_cv = treeDataCV
				if (treeDataCV[order] === undefined)
					treeDataCV[order] = []
				if (treeDataCV[order][langid] === undefined)
					treeDataCV[order][langid] = []
				let i = treeDataCV[order][langid].length
				// aux_doc_cv[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				aux_doc_cv[order][langid][0] = { id: ++i, id_doc: '', title: v.name, link: v.link, visible: true }
				setTreeDataCV(aux_doc_cv)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc(files_aux)
	}

	const onChangeHandlerFilesEM = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_em_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_em_name(aux2)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_em
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_em(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'photo') {
					dados.current.info.foto = [
						{
							id: i,
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}
				else if (type === 'cv') {
					dados.current.info.cv = [
						{
							id: i,
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}
				else if (type === 'em') {
					dados.current.info.exame_medico = [
						{
							id: i,
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						}
					];
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}


	/*
	const uploadFile = async (files) => {
		const file = files[0];
		const formData = new FormData();
		formData.append('id', dados.current.id);
		formData.append('file_name', file.name);
		//formData.append('unique_code', dados.current.info.unique_code);
		formData.append('companycode', dados.current.info.companycode);
		formData.append('type', 'foto'); // Definindo como foto
		formData.append('files', file);
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

		console.log('file', file);
		console.log('formData', formData);

		return

		try {
			const res = await reqFILE(`${Hosts.SIMCore_API}/multimedia/file`, formData);

			if (res.data.name !== undefined) {
				if (dados.current.info.foto === undefined) {
					dados.current.info['foto'] = [];
				}

				dados.current.info.foto = [
					{
						name: file.name,
						type: file.type,
						size: file.size,
						path: res.data.path,
						source_name: res.data.name,
						link: res.data.path + '' + res.data.name,
					},
				];

				set_dados([...dados.current.info.foto]);

				await reqPUT(api_crud_route, dados.current);

				setFiles([]); // Limpar os arquivos selecionados
			}
		} catch (error) {
			console.error('Erro ao enviar arquivo:', error);
			alert(language[lang].edit_error);
		}
	};
	*/


	const handle_change_tree = (tD, order, langid) => {

		treeDataCV[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}
		else {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const remove_element_tree_cv = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataCV[order][langid].filter(v => v.id !== id)
					treeDataCV[order][langid] = treeAux
					setTreeDataCV(treeDataCV)

					let aux = []
					if (langid === '1') {
						dados.current.info.cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info.cv = aux)
					}
					else {
						dados.current.info['language'][langid].cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info['language'][langid].cv = aux)
					}

				}
			})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataCV[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataCV(treeDataCV)
		set_dados(dados.current.content[order],)
	}

	const change_funcao = (selected) => {
		const value = Array.isArray(selected) ? 
			selected.map(s => ({ id: s.value, name: s.label }))
		: 
			[];

		if(dados?.current?.info?.attributes === undefined) {
			dados.current.info.attributes = {}
		}
		if(dados?.current?.info?.attributes?.entity_profile === undefined) {
			dados.current.info.attributes.entity_profile = []
		}

		set_dados(dados.current.info.attributes.entity_profile = value);
	}

	const change_clube = (selected) => {
		const value = Array.isArray(selected) ? 
			selected.map(s => ({ id: s.value, name: s.label }))
		: 
			[];

		set_dados(dados.current.info.clube = value);
	}

	const change_modalidade = (selected) => {
		const value = Array.isArray(selected) ? 
			selected.map(s => ({ id: s.value, name: s.label }))
		: 
			[];

		if(dados?.current?.info?.modalidades === undefined) {
			dados.current.info.modalidades = []
		}

		// set_dados(dados.current.info.modalidades = value);
		if(selected[parseInt(selected.length) - 1] !== undefined) {
			set_dados(dados.current.info.modalidades = [{ id: selected[parseInt(selected.length) - 1].value, name: selected[parseInt(selected.length) - 1].label }]);
		}
		else {
			set_dados(dados.current.info.modalidades = []);
		}

		setRefresh(r => r + 1)
	}

	const change_outras_modalidades = (selected) => {
		const value = Array.isArray(selected) ? 
			selected.map(s => ({ id: s.value, name: s.label }))
		: 
			[];

		if(dados?.current?.info?.outras_modalidades === undefined) {
			dados.current.info.outras_modalidades = []
		}

		set_dados(dados.current.info.outras_modalidades = value);
	}

	const handle_change_encarregados = (pessoa, campo, valor) => {
		const atual = dados.current.info.encarregados ?? {};
		set_dados(dados.current.info.encarregados = {
			...atual,
			[pessoa]: { ...atual[pessoa], [campo]: valor },
		});


		console.log('dados.current.info.encarregados', dados.current.info.encarregados)

	};

	const anoNascimento = (birthday) => {
		if (!birthday) return null;
		const ano = parseInt(String(birthday).slice(0, 4), 10);
		return Number.isNaN(ano) ? null : ano;
	};

	const escalaoPorAno = (ano, tabela) => {
		if (ano === null) return '';
		const item = tabela.find(e => ano >= e.min && ano <= e.max);
		return item ? item.id : '';
	};

	// Idade de referência = idade que o atleta tem a 1 de julho do ano em que a época começa
	const idadeReferencia = (birthday, anoEpoca) => {
		if (!birthday) return null;
		const nascimento = new Date(birthday);
		const referencia = new Date(anoEpoca, 6, 1); // 1 de julho
		let idade = referencia.getFullYear() - nascimento.getFullYear();
		const diffMes = referencia.getMonth() - nascimento.getMonth();
		if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
		return idade;
	};

	// Faixas sobrepostas (Novatos/Juniores/Seniores) -> prioridade: mais "novo" primeiro
	const escalaoPorIdade = (idade) => {
		if (idade === null) return '';
		if (idade >= 28) return 'ADULTOS';
		if (idade > 13 && idade <= 18) return 'JUNIORES';
		if (idade >= 8 && idade <= 13) return 'NOVATOS';
		if (idade >= 17) return 'SENIORES';
		if (idade >= 6) return 'PRE_INICIADO';
		return '';
	};

	const detectarGrupoModalidade = (modalidades) => {
		if (!Array.isArray(modalidades) || modalidades.length === 0) 
			return 'geral';
		
		const valores = modalidades.map(m => (m.id ?? m.name ?? m ?? '').toString().toLowerCase());
		
		if (valores.some(v => v.includes('patinagem'))) 
			return 'patinagem';
		if (valores.some(v => v.includes('snowboard'))) 
			return 'snowboard';
		
		return 'geral';
	};

	// anoEpoca = ano civil em que a época desportiva começa (ex: 2025 para a época 2025/2026)
	const calcularEscalao = (birthday, modalidades, anoEpoca) => {

		console.log('birthday', birthday)
		console.log('modalidades', modalidades)
		console.log('anoEpoca', anoEpoca)

		const grupo = detectarGrupoModalidade(modalidades);
		console.log('grupo', grupo)
		if (grupo === 'patinagem') {
			return escalaoPorIdade(idadeReferencia(birthday, anoEpoca));
		}
		const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL;
		return escalaoPorAno(anoNascimento(birthday), tabela);
	};

	const grupoModalidadeAtual = detectarGrupoModalidade(dados.current.info.modalidades);
	const opcoesEscalaoAtual = OPCOES_ESCALAO[grupoModalidadeAtual];

	return isloading ?
		<Loader />
	:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].meus_dados}</h2>
					<p>{language[lang].meus_dados} / {dados.current.id !== '' ? language[lang].editar_dados : language[lang].entity_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0 d-flex justify-content-between align-items-center p-4">
										<h3 className="fw-bolder m-0 text-nowrap">
											{language[lang].edit} {language[lang].dados_pessoais}
										</h3>

										<div className="d-flex flex-row flex-wrap">
											<button
												className={`btn rounded-pill btn-sm py-1 px-4 me-2 ${showOverView ? 'btn-primary' : 'btn-outline-secondary'}`}
												onClick={() => {
													setShowOverview(true);
													setShowSportsData(false);
													setShowSettings(false);
													setShowGuardians(false);
												}}
											>
												{language[lang].overview}
											</button>

											<button
												className={`btn rounded-pill btn-sm py-1 px-4 me-2 ${showSportsData ? 'btn-primary' : 'btn-outline-secondary'}`}
												onClick={() => {
													setShowSportsData(true);
													setShowSettings(false);
													setShowOverview(false);
													setShowGuardians(false);
												}}
											>
												{language[lang].sports_data}
											</button>

											{
											is_minor ?
												<button
													className={`btn rounded-pill btn-sm py-1 px-4 me-2 ${showGuardians ? 'btn-primary' : 'btn-outline-secondary'}`}
													onClick={() => {
														setShowGuardians(true);
														setShowSettings(false);
														setShowOverview(false);
														setShowSportsData(false);
													}}
												>
													{language[lang].parents_data}
												</button>
											:
												null
											}

											<button
												className={`btn rounded-pill btn-sm py-1 px-4 ${showSettings ? 'btn-primary' : 'btn-outline-secondary'}`}
												onClick={() => {
													setShowSettings(true);
													setShowSportsData(false);
													setShowOverview(false);
													setShowGuardians(false);
												}}
											>
												{language[lang].settings}
											</button>
										</div>
									</div>

									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="tab-content">
													{showOverView && (
														<div className="row">
															<div className="col-12 col-md-8 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].name} *</label>
																<input
																	type="text"
																	name="name"
																	value={dados.current.info.name}
																	className="form-control rounded-0"
																	placeholder={language[lang].name_placeholder}
																	onChange={handle_change_info}
																	required
																/>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].vat}</label>
																<input
																	type="text"
																	pattern={pattern_vat}
																	minLength="9"
																	inputMode='numeric'
																	name="vat"
																	value={dados.current.info.vat}
																	className="form-control rounded-0"
																	placeholder={language[lang].vat_placeholder}
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showOverView && (
														<div className="row">
															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].identification_number_type} *</label>
																<select className="form-select rounded-0" aria-label="Select Type" name='tipo_identificacao' value={dados.current.info.identificacao.tipo_identificacao} onChange={handle_change_info_identification}>
																	{['cc', 'bi', 'autorizacao_residencia', 'passaporte'].map((tipo) => (
																		<option value={tipo}>{language[lang][tipo]}</option>
																	))}
																</select>
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].identification_number} *</label>
																<input
																	type="text"
																	name="numero_identificacao"
																	value={dados.current.info.identificacao.numero_identificacao}
																	className="form-control rounded-0"
																	placeholder={language[lang].identification_number_placeholder}
																	onChange={handle_change_info_identification}
																	required
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].identification_validation} *</label>
																<input
																	type="date"
																	name="validade_identificacao"
																	value={dados.current.info.identificacao.validade_identificacao}
																	className="form-control rounded-0"
																	onChange={handle_change_info_identification}
																	required
																/>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].email} *</label>
																<input
																	type="email"
																	pattern={pattern_email}
																	name="email"
																	value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email}
																	className="form-control rounded-0"
																	placeholder={language[lang].email_placeholder}
																	onChange={handle_change_contacts}
																	required
																/>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].tlf}</label>
																<input
																	type="tel"
																	name="phone"
																	value={dados.current.contacts[0].phone}
																	className="form-control rounded-0"
																	placeholder={language[lang].tlf_placeholder}
																	onChange={handle_change_contacts}
																/>																
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].tlm} *</label>
																<input
																	type="tel"
																	name="mobile_phone"
																	value={dados.current.contacts[0].mobile_phone}
																	className="form-control rounded-0"
																	placeholder={language[lang].tlm_placeholder}
																	onChange={handle_change_contacts}
																	required
																/>
															</div>
														</div>
													)}

													{showOverView && (
														<div className="row">
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].nacionalidade} *</label>
																<input
																	type="text"
																	name="nacionalidade"
																	value={dados?.current?.info?.identificacao?.nacionalidade !== undefined ? dados.current.info.identificacao.nacionalidade : ''}
																	className="form-control rounded-0 d-none"
																	placeholder={language[lang].nacionalidade_placeholder}
																	onChange={handle_change_info_identification}
																	required
																/>
																<Select
																	className="div-select"
																	options={countries}
																	name="nacionalidade"
																	value={dados?.current?.info?.identificacao?.nacionalidade === '' ? null : { label: dados.current.info.identificacao.nacionalidade, value: dados.current.info.identificacao.nacionalidade }}
																	placeholder={language[lang].country_placeholder}
																	onChange={change_nacionalidade}
																/>
															</div>
															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].naturalidade} *</label>
																<input
																	type="text"
																	name="naturalidade"
																	value={dados?.current?.info?.identificacao?.naturalidade !== undefined ? dados.current.info.identificacao.naturalidade : ''}
																	className="form-control rounded-0"
																	placeholder={language[lang].naturalidade_placeholder}
																	onChange={handle_change_info_identification}
																	required
																/>
															</div>

															<div className="col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].birthday} *</label>
																<input
																	type="date"
																	name="birthday"
																	value={dados.current.info.birthday !== '' ? dados.current.info.birthday : ''}
																	className="form-control rounded-0"
																	onChange={handle_change_info}
																	required
																/>
															</div>

															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].profissao} *</label>
																<input
																	type="text"
																	name="profissao"
																	value={dados.current.info.profissao}
																	className="form-control rounded-0"
																	placeholder={language[lang].profissao_placeholder}
																	onChange={handle_change_info}
																	required
																/>
															</div>
															{
															dados.current.info.profissao.toLowerCase() !== 'estudante' ?
																<div className="col-6 col-md-8 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].empresa}</label>
																	<input
																		type="text"
																		name="empresa"
																		value={dados.current.info.empresa}
																		className="form-control rounded-0"
																		placeholder={language[lang].empresa_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															:
																<div className="col-6 col-md-8 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].estabelecimento_ensino}</label>
																	<input
																		type="text"
																		name="estabelecimento_ensino"
																		value={dados.current.info.estabelecimento_ensino}
																		className="form-control rounded-0"
																		placeholder={language[lang].estabelecimento_ensino_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															}
														</div>
													)}

													{showOverView && (
														<div className="row">
															<div className="col-md-8 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].morada} *</label>
																<textarea
																	name="address_detail"
																	value={dados.current.addresses[0].address_detail}
																	className="form-control rounded-0"
																	rows="6"
																	onChange={handle_change_addresses}
																	required
																/>
															</div>

															<div className='col-md-4'></div>

															<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																<label className="fs-6 fw-bold mb-2">{language[lang].postal_code} *</label>
																<input
																	type="text"
																	name="postal_code"
																	value={dados.current.addresses[0].postal_code}
																	className="form-control rounded-0"
																	placeholder={language[lang].postal_code_placeholder}
																	onChange={handle_change_addresses}
																	required
																/>
															</div>

															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].local} *</label>
																<input
																	type="text"
																	name="localidade"
																	value={dados.current.addresses[0].localidade}
																	className="form-control rounded-0"
																	placeholder={language[lang].local_placeholder}
																	onChange={handle_change_addresses}
																	required
																/>

															</div>
															<div className={"col-6 col-md-3 mb-3" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																<label className="fs-6 fw-bold mb-2">{language[lang].district} *</label>
																<input
																	type="text"
																	name="region"
																	value={dados.current.addresses[0].region}
																	className="form-control rounded-0"
																	placeholder={language[lang].district_placeholder}
																	onChange={handle_change_addresses}
																	required
																/>
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].country} *</label>
																<input
																	type="text"
																	name="country"
																	value={dados.current.addresses[0].country}
																	className="form-control rounded-0 d-none"
																	placeholder={language[lang].country_placeholder}
																	onChange={handle_change_addresses}
																	required
																/>
																<Select
																	className="div-select"
																	options={countries}
																	name="country"
																	value={dados?.current?.addresses[0]?.country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
																	placeholder={language[lang].country_placeholder}
																	onChange={change_country}
																/>
															</div>
														</div>
													)}

													{showOverView && (
														<div className="row mt-5 mb-4">
															<h4 className='text-uppercase'>Contacto de Emergência</h4>
															<div className="col-6 col-md-6 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
																<input
																	type="text"
																	name="name"
																	value={dados.current?.info?.emergencia?.name !== undefined ? dados.current.info.emergencia.name : ''}
																	className="form-control rounded-0"
																	placeholder={language[lang].name_placeholder}
																	onChange={handle_change_info_emergency}
																/>

															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].relacao}</label>
																<input
																	type="text"
																	name="relacao"
																	value={dados.current?.info?.emergencia?.relacao !== undefined ? dados.current.info.emergencia.relacao : ''}
																	className="form-control rounded-0"
																	placeholder={language[lang].relacao_placeholder}
																	onChange={handle_change_info_emergency}
																/>
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].contact}</label>
																<input
																	type="text"
																	name="contact"
																	value={dados.current?.info?.emergencia?.contact !== undefined ? dados.current.info.emergencia.contact : ''}
																	className="form-control rounded-0"
																	placeholder={language[lang].contact_placeholder}
																	onChange={handle_change_info_emergency}
																/>
															</div>
														</div>
													)}
													
													{showSportsData && (
														<div className="row">
															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].numero_licenca}</label>
																<input
																	type="number"
																	name="numero_licenca"
																	value={dados.current.info.numero_licenca}
																	className="form-control rounded-0"
																	placeholder={language[lang].numero_licenca_placeholder}
																	onChange={handle_change_info}
																	disabled={true}
																/>
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].genero} *</label>
																<select className="form-select rounded-0" aria-label="Select Type" name='genero' value={dados.current.info.genero} onChange={handle_change_info}>
																	<option value="">{language[lang].choose_option}</option>
																	{['1', '2'].map((tipo) => (
																		<option value={tipo}>{parseInt(tipo) === 1 ? 'Masculino' : 'Feminino'}</option>
																	))}
																</select>
															</div>
															<div className="col-6 col-md-4 mb-3">
																<label className="form-label fw-bold fs-6">{language[lang].escalao}</label>
																<select
																	name="escalao"
																	className="form-select rounded-0"
																	value={dados.current.info.escalao ?? ''}
																	disabled
																	onChange={(e) => {
																		escalaoAutoRef.current = '';
																		handle_change_info(e);
																	}}
																>
																	<option value="">{language[lang].select}</option>
																	{opcoesEscalaoAtual.map((opt) => (
																		<option key={opt.id} value={opt.id}>{opt.label}</option>
																	))}
																</select>
															</div>
														</div>
													)}
													
													{showSportsData && (
														<div className="row">
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].function} *</label>
																{console.log}
																<Select
																	isMulti
																	className="div-select"
																	options={aEntityProfiles}
																	name="entity_profile"
																	value={
																		dados.current.info.attributes !== undefined && Array.isArray(dados.current.info.attributes.entity_profile) ? 
																			dados.current.info.attributes.entity_profile.map(c => ({ value: c.id, label: (c.name !== undefined ? c.name : c.label) }))
																		: 
																			[]
																	}
																	placeholder={language[lang].choose_option}
																	onChange={change_funcao}
																/>
																
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].clube}</label>
																<Select
																	isMulti
																	className="div-select"
																	options={aClubes}
																	name="clube"
																	value={
																		Array.isArray(dados.current.info.clube) ? 
																			dados.current.info.clube.map(c => ({ value: c.id, label: c.name }))
																		: 
																			[]
																	}
																	placeholder={language[lang].choose_option}
																	onChange={change_clube}
																/>
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].modalidade}</label>
																<Select
																	isMulti
																	className="div-select"
																	options={aModalidades}
																	name="modalidades"
																	value={
																		dados.current.info.modalidades !== undefined && Array.isArray(dados.current.info.modalidades) ? 
																			dados.current.info.modalidades.map(c => ({ value: c.id, label: c.name }))
																		: 
																			[]
																	}
																	placeholder={language[lang].choose_option}
																	onChange={change_modalidade}
																/>
															</div>
															<div className="col-6 col-md-3 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].outras_modalidades}</label>
																<Select
																	isMulti
																	className="div-select"
																	options={aModalidades}
																	name="outras_modalidades"
																	value={
																		dados.current.info.outras_modalidades !== undefined && Array.isArray(dados.current.info.outras_modalidades) ? 
																			dados.current.info.outras_modalidades.map(c => ({ value: c.id, label: c.name }))
																		: 
																			[]
																	}
																	placeholder={language[lang].choose_option}
																	onChange={change_outras_modalidades}
																/>
															</div>
														</div>
													)}
													
													{showSportsData && (
														<div className="row">
															<div className="col-12 col-md-6">
																<label className="form-label fw-bold fs-6">{language[lang].federado_outras_modalidades}</label>
																<textarea
																	name="federado_outras_modalidades"
																	value={dados.current.info.federado_outras_modalidades || ''}
																	className="form-control rounded-0"
																	rows="3"
																	onChange={handle_change_info}
																/>
															</div>
															<div className="col-12 col-md-6">
																<label className="form-label fw-bold fs-6">{language[lang].observation}</label>
																<textarea
																	name="observation"
																	value={dados.current.info.observation || ''}
																	className="form-control rounded-0"
																	rows="3"
																	onChange={handle_change_info}
																/>
															</div>
														</div>
													)}

													{showSportsData && (
														<div className="row mb-5 mt-4">
															<div className="col-md-6">
																<div className="div-doc">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].carregar_exame_medico} *
																	</label>

																	<div className="dropzone-panel mb-lg-0 mb-2">
																		<div className="div-form-input col-12 custom-file">
																			<label
																				className="btn btn-outline-primary btn-sm rounded-0"
																				htmlFor={"input-files-pdf-" + '0' + '-' + '1'}>
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id={"input-files-pdf-" + '0' + '-' + '1'}
																				type="file"
																				accept="application/pdf"
																				data-order={'0'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesEM}
																				multiple
																			/>
																		</div>
																	</div>

																	{
																	Array.isArray(dados.current.info.exame_medico) && dados.current.info.exame_medico.length > 0 ?
																		<div className="row">
																			<div className="col-6 col-md-4 mb-3 mt-3">
																				<label className="fs-6 fw-bold mb-2">{language[lang].download}</label>
																				<a href={dados.current.info.exame_medico[0].link} download={dados.current.info.exame_medico[0].name} target="_blank" rel="noreferrer">
																					<button type="button" className='btn-primary py-2 px-3 w-100'>
																						<i className="bi bi-file-earmark-pdf"></i> {dados.current.info.exame_medico[0].name}
																					</button>
																				</a>
																			</div>

																			<div className="col-6 mb-3 mt-3">
																				<label className="fs-6 fw-bold mb-2">{language[lang].data_emissao_exame_medico}</label>
																				<input
																					type="date"
																					name="data_emissao_exame_medico"
																					value={dados.current.info.data_emissao_exame_medico}
																					className="form-control rounded-0"
																					placeholder={language[lang].data_emissao_exame_medico_placeholder}
																					onChange={handle_change_info}
																				/>
																			</div>
																		</div>
																	:
																		null
																	}
																</div>
															</div>
															
															<div className="col-6 mb-3">
																<label className="fs-6 fw-bold mb-2">{language[lang].seguro_opcional} (€{SEGURO_OPCIONAL_VALOR.toFixed(2)}) *</label>
																<select className="form-select rounded-0" aria-label="Select Type" name='seguro_opcional' value={dados.current.info.seguro_opcional} onChange={handle_change_info}>
																	<option value="">{language[lang].choose_option}</option>
																	{['0', '1'].map((tipo) => (
																		<option value={tipo}>{parseInt(tipo) === 0 ? 'Não' : 'Sim'}</option>
																	))}
																</select>
															</div>
														</div>
													)}

													{showGuardians && is_minor && (
														<div className="">
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].pais_encarregados} *</h6>
															<div className="">
																{[
																	{ key: 'pai', label: language[lang].nome_contacto_pai },
																	{ key: 'mae', label: language[lang].nome_contacto_mae },
																	{ key: 'encarregado_educacao', label: language[lang].nome_contacto_encarregado }
																].map((pessoa) => (
																	<div key={pessoa.key} className="row g-3 mb-4">
																		<div className="col-7">
																			<label className="form-label fw-bold fs-6">{pessoa.label}</label>
																			<input
																				type="text"
																				className="form-control rounded-0"
																				value={dados.current.info.encarregados?.[pessoa.key]?.nome ?? ''}
																				onChange={(e) => handle_change_encarregados(pessoa.key, 'nome', e.target.value)}
																			/>
																		</div>
																		<div className="col-5">
																			<label className="form-label fw-bold fs-6">{language[lang].tlm}</label>
																			<input
																				type="tel"
																				name="contacto"
																				value={dados.current.info.encarregados?.[pessoa.key]?.contacto ?? null}
																				className="form-control rounded-0"
																				placeholder={language[lang].tlm_placeholder}
																				onChange={(e) => handle_change_encarregados(pessoa.key, 'contacto', e.target.value)}
																			/>
																		</div>
																	</div>
																))}
															</div>
														</div>
													)}

													{showSettings && (
														<div className="row mb-4 rounded p-4">
															<div className="col-md-4 mb-3">
																<div className="mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].username}
																	</label>
																	<input
																		type="text"
																		name="username"
																		value={dados.current.info.username}
																		pattern="[a-zA-Z\u00C0-\u00FF.]+"
																		className="form-control rounded-0"
																		placeholder={language[lang].username_placeholder}
																		onChange={handle_change_info}
																		onBlur={handle_change_login}
																		autoComplete="off"
																		disabled={true}
																	/>
																</div>

																<div className="mb-3">
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].password}
																	</label>
																	<input
																		type="password"
																		name="password"
																		value={new_password}
																		min="9"
																		title="A password deve de conter pelo menos 9 digitos alfa-númericos"
																		className="form-control rounded-0"
																		placeholder={is_edit ? "*************" : language[lang].password_placeholder}
																		onChange={handle_change_info_new_password}
																		autoComplete="off"
																	/>
																</div>

																<div>
																	<label className="fs-6 fw-bold mb-2">
																		{language[lang].password_confirmation}
																	</label>
																	<input
																		type="password"
																		name="password_conf"
																		defaultValue={confirm_password}
																		min="9"
																		className="form-control rounded-0"
																		placeholder={is_edit ? "*************" : language[lang].password_placeholder}
																		onBlur={handle_change_password}
																		autoComplete="off"
																	/>
																</div>
															</div>

															<div className="col-md-6 p-4 rounded">
																<div className="mt-4">
																	<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center mb-3">
																		<li>
																			<label className="fs-6 fw-bold mb-2">
																				{language[lang].fotografia} *
																			</label>
																		</li>
																	</ul>
																	<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
																		{
																			photo_base64 !== '' ?
																				<img
																					src={photo_base64}
																					className="img-fluid rounded"
																					alt="Uploaded"
																					style={{ width: "120px", height: "120px", objectFit: "cover" }}
																				/>
																			:
																				dados?.current?.info?.foto?.length > 0 ? (
																					dados.current.info.foto.map((file, index) => {
																						const imageURL = file.link || URL.createObjectURL(file);
																						return (
																							<li key={index} className="d-flex flex-column align-items-center">
																								<img
																									src={imageURL}
																									className="img-fluid rounded"
																									alt="Uploaded"
																									style={{ width: "120px", height: "120px", objectFit: "cover" }}
																								/>
																								<small className="mt-2 text-muted d-none">{file.name || 'Imagem'}</small>
																							</li>
																						);
																					})
																				) : (
																					<li className="text-muted">{language[lang].noPhoto}</li>
																				)}
																	</ul>

																	<div className="d-flex justify-content-center mt-4 gap-2">
																		<input
																			type="file"
																			accept="image/*"
																			data-order={1}
																			data-langid={lang_id}
																			data-lang={lang}
																			data-type={'image'}
																			className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																			onChange={onChangeHandlerFilesImage}
																			id="photo-upload"
																		/>

																		<label htmlFor="photo-upload" className="btn btn-outline-primary btn-sm rounded-0">
																			{language[lang].photo}
																		</label>

																		{dados?.current?.info?.foto?.length > 0 && (
																			<button
																				type="button"
																				className='btn btn-sm btn-danger rounded-0'
																				onClick={handleFileRemove}
																			>
																				<i className="bi bi-x-lg"></i>
																			</button>
																		)}
																	</div>
																</div>
															</div>
														</div>
													)}

												</div>
											</div>
										</form>
									</div>
								</div>
							</div>

							<button id={'btn_modal_payment_type'} type="button" className="btn btn-sm btn-secondary rounded-0 me-2 d-none" data-bs-toggle="modal" data-bs-target={"#modal_payment_type"}></button>

							<div className="modal bg-light fade" tabIndex="0" id={"modal_payment_type"} role="dialog">
								<div className="modal-dialog modal-dialog-centered">
									<div className="modal-content shadow-none">
										<div className="modal-header d-none">
											<h5 className="modal-title"></h5>

											<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
												<i className="bi bi-x fs-2"></i>
											</div>
										</div>

										<div className="modal-body">
											<div className="pb-10">

												<div>
													<div className="my-3">
														<h3 className="titulo-primario">{language[lang].dados_tipo_pagamento}</h3>
														<p><strong>{language[lang].valor_a_pagar}:</strong> {nota_de_encomenda?.current?.info?.documento !== undefined ? parseFloat(nota_de_encomenda.current.info.documento.total_documento).toFixed(2).toString().replace('.', ',') : '0.00'}€</p>
													</div>

													<div className="row mb-4">
														<div className='col-12'>
															<p>
																<strong>{language[lang].tb_iban}:</strong> {fdi_iban.current}
															</p>
															<p>
																<strong>{language[lang].tb_attention}:</strong> {language[lang].tb_details}
															</p>
														</div>
														
														<div className='col-6 col-sm-4 mx-auto'> 
															<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('tb', '2')}><img className='img-fluid' src={repo_img_link("transferencia.svg")} alt="tb" /></button>
														</div>

													</div>

													<div className="row mb-3 d-none">
														
														<div className='col-6 col-sm-4'> 
															<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('mbw', '-1')}><img className='img-fluid' src={repo_img_link("mbway-square.png")} alt="mbw" /></button>
														</div>
														<div className='col-6 col-sm-4'> 
															<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('mb', '1')}><img className='img-fluid' src={repo_img_link("mb-square.png")} alt="rm" /></button>
														</div>
														<div className='col-6 col-sm-4'> 
															<button type='button' className='btn btn-outline-light shadow' onClick={() => set_paymet('cc', '0')}><img className='img-fluid' src={repo_img_link("cc-square.png")} alt="cc" /></button>
														</div>

													</div>

												</div>

											</div>
										</div>

										<div className="modal-footer">
											<button type="button" className="btn btn-light" data-bs-dismiss="modal">{language[lang].close}</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									{/*
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.main }} replace>
										<i className="bi bi-arrow-left"></i>
										<span> {language[lang].back}</span>
									</Link> 
									*/}
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>

									{
									pay_fee_available.current ?
										<button type="button" className="btn btn-success mt-1 me-2 py-2 px-3" onClick={() => pay_fee()}>
											<i className="bi bi-credit-card me-2"></i>
											<span>{language[lang].pay_fee}</span>
										</button>
									:
										null
									}
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
